import React, { useState, useEffect  } from 'react'
import {
  Row,
  Col,
  Button,
  CustomInput,
  Input,
  Form,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from "react-redux";
import EvalChunkComparison from './EvalChunkComparison'
import * as MyAPI from '../../../utils/MyAPI'

// EvalScoreUpdateEach
const EvalScoreUpdateEach = (props) => {

  let [correspondenceReady, setCorrespondenceReady] = useState(false)
  let [evalSeikaiArr, setEvalSeikaiArr] = useState([])
  let [evalPredictionArr, setEvalPredictionArr] = useState([])
  let [wer, setWer] = useState('')
  let [resultPairList, setResultPairList] = useState(null)
  let [blankIndex, setBlankIndex] = useState(-1)
  let [savedPairListExists, setSavedPairListExists] = useState(false)

  // componentDidMount
  useEffect(() => {

    // console.log("")
    // console.log("------------")

    if (props.seikaiProcessed && props.item.processed_texts) {
      // create pair

      // console.log("EvalScoreUpdateEach. item: ", props.item )
      // console.log("EvalScoreUpdateEach. seikaiProcessed: ", props.seikaiProcessed )

      _create_correspondence()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.item, props.seikaiProcessed]);

  // create pair
  let _create_correspondence = async () => {

    if (!props.seikaiProcessed) {
      return
    }

    if (!props.item.processed_texts) {
      return
    }

    // get seikai prediction pair.
    // we need to pass process texts instead of raw transcript
    let _results = await props.create_correspondence({
      seikaiTexts: props.seikaiProcessed,
      predictedTexts: props.item.processed_texts,
    })

    // console.log("_results: ", _results)

    if (_results) {
      setEvalSeikaiArr(_results.seikai_arr)
      setEvalPredictionArr(_results.prediction_arr)
    }

    // setCorrespondenceReady(true)
  }



  // componentDidMount
  useEffect(() => {

    if (evalSeikaiArr.length !== 0 && evalPredictionArr.length !== 0) {
      setCorrespondenceReady(true)
    } else {
      setCorrespondenceReady(false)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evalSeikaiArr, evalPredictionArr]);








  // _savePredictionAndWer
  let _savePredictionAndWer = ({
    wer,
    humanScore,
    pairList,
  }) => {
    props.savePredictionAndWer({
      wer: wer,
      humanScore: humanScore,
      pairList: pairList,
      logItem: props.item,
    })
  }

  // reportWer
  let _reportWer = (_wer) => {

    // console.log("")
    // console.log("evalSeikaiArr: ", evalSeikaiArr)

    let _seikai_count = 0
    let _seikai_arr2 = []
    for (let i=0; i<evalSeikaiArr.length; i++) {
      if (evalSeikaiArr[i] !== "_" && evalSeikaiArr[i] !== "") {
        _seikai_count = _seikai_count + 1
        _seikai_arr2.push(evalSeikaiArr[i])
      }
    }
    console.log("_reportWer: ", _wer.toFixed(2), props.item.engine_nickname, _seikai_count)
    console.log("")

    props.saveChunkWer({
      engine_nickname: props.item.engine_nickname,
      wer: parseFloat(_wer.toFixed(4)),
      count: _seikai_count,
    })

    setWer(_wer.toFixed(3))
  }


  // _handleBlankIndex
  let _handleBlankIndex = (e) => {
    setBlankIndex(e.target.value)
  }

  // _blankIndexRight
  let _blankIndexRight = () => {
    setBlankIndex(blankIndex+1)
  }

  // _blankIndexLeft
  let _blankIndexLeft = () => {
    if (blankIndex > -1) {
      setBlankIndex(blankIndex-1)
    }
  }

  // _deleteSavedPairList
  let _deleteSavedPairList = () => {

    props.deleteSavedPairList({
      logItem: props.item,
    })
  }


  return (

      <div className="shadow2dp" style={{
        marginTop: 20,
        marginBottom: 20,
        backgroundColor: '#ffffff',
        padding: 20,
      }}>

        <Row style={{
          marginTop: 20,
          marginBottom: 20,
        }}>
          <Col md="6" xs="12">
            <span>{props.item.engine_nickname}</span>
          </Col>

          <Col md="3" xs="12" style={{
            textAlign: 'right',
          }}>
          </Col>

          <Col md="3" xs="12" style={{
            textAlign: 'right',
          }}>

            <span style={{
              marginRight: 6,
              fontWeight: 'bold',
            }}>
              WER: {wer}
            </span>
          </Col>

        </Row>

        {correspondenceReady === true && (
          <EvalChunkComparison
            wer={wer}
            accountType={props.accountType}
            pairList={resultPairList}
            blankIndex={blankIndex}
            setBlankIndex={setBlankIndex}
            engineType={props.item.engineType}
            humanScore={props.item.humanRatings}
            reportWer={_reportWer}
            savePredictionAndWer={_savePredictionAndWer}
            evalSeikaiArr={evalSeikaiArr}
            evalPredictionArr={evalPredictionArr} />
        )}

      </div>

  )
}

export default EvalScoreUpdateEach
